export const view = {
    namespaced: true,
    state() {
        return {
            view: {
                portfolio:null,
                project:null,
                user:null,
                portfolioPages:[],
                caseStudies:[],
                activePage:null,
                footerProjects:[],
                navOpen:false,
                fontsLoaded:false,
                ownDomain:null,
                publicPages: {
                    activeMode: "light"
                },
                showcaseItems: null,
                selectedShowcaseItem: null,
                emergencyModeSettings: null,
                stickedHeader:false,
                generationPreviewId: null,
            },
            viewModeReady:false,
            viewModePreloadFailed:false
        }
    },
    getters: {
        isViewModeReadyToLoad(state) {
            return state.viewModeReady
        },
        viewData(state) {
            return state.view
        },
        normalizedHost() {
            if (typeof window === "undefined") return "";
            return window.location.host.replace(/^www\./i, "").split(":")[0].toLowerCase();
        },
        caseStudyRoute(state, getters) {
            return (shortId) => {
                const portfolio = getters.viewData.portfolio || {};
                const ownDomain = portfolio.ownDomainAddress;
                if (!shortId || !portfolio.shortId) return null;

                if (getters.viewData.generationPreviewId) {
                    return `/portfolio-generation/${encodeURIComponent(getters.viewData.generationPreviewId)}/preview/${encodeURIComponent(shortId)}`;
                }

                return ownDomain && ownDomain.toLowerCase() === getters.normalizedHost
                    ? `/p/${shortId}`
                    : `/p/${portfolio.shortId}/${shortId}`;
            }
        }
    },
    actions: {

    },
    mutations: {
        updateView(state, view) {
            state.view = {...state.view, ...view}
        },
        updateViewModeReadiness(state, isReady) {
            state.viewModeReady = isReady
        },
        updateViewModePreloadFailed(state, hasFailed) {
            state.viewModePreloadFailed = hasFailed
        },
        updateActivePage(state, activePage) {
            state.view.activePage = activePage
        },
        updateViewUser(state, user) {
            state.view.user = user;
        },
        setFontsLoaded(state, loaded) {
            state.view.fontsLoaded = true
        },
        updateActiveMode(state, newMode) {
            state.view.publicPages.activeMode = newMode;
        },
        clearViewMode(state) {
            state.view = {
                portfolio: null,
                project: null,
                user: null,
                portfolioPages: null,
                activePage: null,
                footerProjects: [],
                navOpen: false,
                fontsLoaded: false,
                ownDomain: null,
                publicPages: {
                    activeMode: "light"
                },
                showcaseItems: null,
                selectedShowcaseItem: null,
                emergencyModeSettings: null,
                stickedHeader: false,
                generationPreviewId: null
            }
        },
        updateViewPortfolio(state, portfolio) {

        },
        updateViewProject(state, project) {
            state.view.project = project
        }
    }
}
